import { render } from "./ChangeBadgeIcon.vue?vue&type=template&id=8af516f4"
import script from "./ChangeBadgeIcon.vue?vue&type=script&lang=js"
export * from "./ChangeBadgeIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__